import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import type { Breakpoint } from "@mui/system";

export const useDeviceBreakpoint = (breakpoint: Breakpoint) => {
  const { breakpoints } = useTheme();

  return useMediaQuery(breakpoints.down(breakpoint));
};
